import { Installation } from 'src/Libs/installations/models/installation.model'

export const INSTALLATION_FILTER_PROPERTIES_ALL: (keyof Installation)[] = [
  'id',
  'emsMasterDeviceId',
  'emsMasterProduct',
  'createdAt',
  'ownerFullName',
  'createdByFullName',
  'projectName',
  'partnersInstallationName',
  'ownerCompanyName',
  'ownerUsername', // can be filtered by but is currently not visible to the user in the table
  'createdByUsername', // can be filtered by but is currently not visible to the user in the table
]

export const INSTALLATION_FILTER_PROPERTIES_REDUCED: (keyof Installation)[] = [
  'id',
  'emsMasterProduct',
  'createdAt',
  'ownerFullName',
  'createdByFullName',
  'ownerUsername', // can be filtered by but is currently not visible to the user in the table
  'createdByUsername', // can be filtered by but is currently not visible to the user in the table
]

export const INSTALLATION_FILTER_PROPERTIES_MOBILE_VIEW: (keyof Installation)[] = [
  'id',
  'emsMasterProduct',
  'createdAt',
  'ownerFullName',
  'ownerUsername', // can be filtered by but is currently not visible to the user in the table
  'createdByUsername', // can be filtered by but is currently not visible to the user in the table
]
